// import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class commonState extends baseState {
    getUploadProgress = (data) => {
        return this.fetch({
            url: apiUrl.COMMON.UPLOAD_PROGRESS + data.progressKey,
            method: 'get',
        });
    }

    getLanguageList = data => {
        return this.fetch({
            url: apiUrl.LANGUAGE_LIST,
            method: "get",
            data
        });
    }

    getTagList = data => {
        return this.fetch({
            url: apiUrl.VALID_LIST,
            method: "get",
            data
        });
    }

    /**
     *  轮询状态的接口
     *   lockKey：
     *          reindex_media   重建ES公网索引
     *          reindex_media_cibn  重建CIBN索引
     *          reindex_media_newtv 重建未来电视索引
     *          leishi_media_sync   雷石歌曲同步
     *          QQPortraitCrawlerStatus QQ图片爬取
     */
    getStatus = (data) => {//
        return this.fetch({
            url: apiUrl.CONFIG_STATUS + data.lockKey,
            method: "get",
            data
        });
    };
}
